import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import { DropDown } from "../DropDown/DropDown";
import classes from "./CoachDetailsScheduleCard.module.css";
import { GetDaysBetweenDates } from "../../util/CustomFunctions";
import moment from "moment";
import { ReactSVG } from "react-svg";
import { BackwardArrow, ForwardArrow } from "../../constant/imagePath";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";

function CoachDetailsScheduleCard({
  data,
  btnText = "Continue booking",
  onClick,
}) {
  const [pageNo, setPageNo] = useState(1);
  const [dateArray, setDateArray] = useState([]);
  const [searchTimings, setSearchTimings] = useState([]);
  const [location, setLocation] = useState();
  const limit = 4;

  useEffect(() => {
    const dateList = GetDaysBetweenDates(
      moment(data?.timing[0]?.date),
      moment(data?.timing[data?.timing.length - 1]?.date)
    );
    setDateArray(dateList);
  }, []);

  useEffect(() => {
    if (dateArray.length > 0) {
      HandleDateData(dateArray.slice(limit * (pageNo - 1), limit * pageNo));
    }
  }, [pageNo, dateArray]);

  const HandleDateData = (d) => {
    let newArray = d.slice();
    d?.map((item, index) => {
      data?.timing?.map((innerItem, innerIndex) => {
        if (
          moment(item).format("YYYY-MM-DD") ==
          moment(innerItem?.date).format("YYYY-MM-DD")
        ) {
          newArray.splice(index, 1, innerItem);
        }
      });
    });
    setSearchTimings(newArray);
  };

  console.log({ searchTimings, pageNo });
  console.log("con", Math.round(data?.timing?.length / limit), pageNo);

  return (
    <div className={classes.card}>
      {/* Headings */}
      <div className={classes.header}>
        <h5 style={{ ...Fonts.h5 }}>Schedule</h5>
        <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
          1-on-1 Tennis Coaching
        </p>
      </div>
      <div className={classes.mb16}>
        <DropDown
          label={"Choose Location"}
          labelClassName={classes.label}
          state={location}
          setter={setLocation}
        />
      </div>
      <Row className={` ${classes.mb16}`}>
        <Col md={3} className={classes.dateAndTimings}>
          <div className={`${[classes.aCenter, classes.mb20].join(" ")}`}>
            <ReactSVG
              src={BackwardArrow}
              beforeInjection={(svg) => svg.classList.add(classes.arrow)}
              onClick={() => {
                if (pageNo > 1) {
                  setPageNo((p) => --p);
                }
              }}
            />
            <div className={classes.dayAndDate}>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                {moment(searchTimings[0]?.date).format("ddd")}
              </p>
              <h6
                style={{
                  ...Fonts.h9,
                  lineHeight: "20px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                {moment(searchTimings[0]?.date).format("DD MMM")}
              </h6>
            </div>
          </div>
          {searchTimings[0]?.time?.map((item) => (
            <Col md={12} className={classes.time}>
              <Button
                label={item}
                primary={false}
                customStyle={{
                  fontFamily: "inter-400",
                  width: "100%",
                  padding: "8px 0px",
                }}
                size={"Small"}
              />
            </Col>
          ))}
        </Col>
        <Col md={3} className={classes.dateAndTimings}>
          <div className={`${[classes.dayAndDate, classes.mb20].join(" ")}`}>
            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
              {moment(searchTimings[1]?.date).format("ddd")}
            </p>
            <h6
              style={{
                ...Fonts.h9,
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {moment(searchTimings[1]?.date).format("DD MMM")}
            </h6>
          </div>
          {searchTimings[1]?.time?.map((item) => (
            <Col md={12} className={classes.time}>
              <Button
                label={item}
                primary={false}
                customStyle={{
                  fontFamily: "inter-400",
                  width: "100%",
                  padding: "8px 0px",
                }}
                size={"Small"}
              />
            </Col>
          ))}
        </Col>
        <Col md={3} className={classes.dateAndTimings}>
          <div className={`${[classes.dayAndDate, classes.mb20].join(" ")}`}>
            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
              {moment(searchTimings[2]?.date).format("ddd")}
            </p>
            <h6
              style={{
                ...Fonts.h9,
                lineHeight: "20px",
                color: Colors.neutralShadesOfNero,
              }}
            >
              {moment(searchTimings[2]?.date).format("DD MMM")}
            </h6>{" "}
          </div>
          {searchTimings[2]?.time?.map((item) => (
            <Col md={12} className={classes.time}>
              <Button
                label={item}
                primary={false}
                customStyle={{
                  fontFamily: "inter-400",
                  width: "100%",
                  padding: "8px 0px",
                }}
                size={"Small"}
              />
            </Col>
          ))}
        </Col>
        <Col md={3} className={classes.dateAndTimings}>
          <div className={`${[classes.aCenter, classes.mb20].join(" ")}`}>
            <div className={classes.dayAndDate}>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                {moment(searchTimings[3]?.date).format("ddd")}
              </p>
              <h6
                style={{
                  ...Fonts.h9,
                  lineHeight: "20px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                {moment(searchTimings[3]?.date).format("DD MMM")}
              </h6>{" "}
            </div>
            <ReactSVG
              src={ForwardArrow}
              beforeInjection={(svg) => svg.classList.add(classes.arrow)}
              onClick={() => {
                if (Math.round(data?.timing?.length / limit) > pageNo) {
                  setPageNo((p) => ++p);
                }
              }}
            />
          </div>
          {searchTimings[3]?.time?.map((item) => (
            <Col md={12} className={classes.time}>
              <Button
                label={item}
                primary={false}
                customStyle={{
                  fontFamily: "inter-400",
                  width: "100%",
                  padding: "8px 0px",
                }}
                size={"Small"}
              />
            </Col>
          ))}
        </Col>
      </Row>
      <div className={classes.continueBtn}>
        <Button
          label={btnText}
          primary={true}
          customStyle={{ padding: "12px 0px" }}
          size={"Large"}
          onClick={onClick}
        />
      </div>
    </div>
  );
}

export default CoachDetailsScheduleCard;

CoachDetailsScheduleCard.propTypes = {
  data: PropTypes.object,
};

CoachDetailsScheduleCard.defaultProps = {
  data: {
    timing: [
      {
        date: moment().format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(1, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(3, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(4, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(7, "days").format(),
        time: [],
      },
      {
        date: moment().add(8, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(9, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(10, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(12, "days").format(),
        time: [],
      },
      {
        date: moment().add(13, "days").format(),
        time: ["10:30 AM", "11:30 AM", "12:30 PM", "05:30 PM", "06:30 PM"],
      },
      {
        date: moment().add(14, "days").format(),
        time: [],
      },
    ],
  },
};
